<template>
  <div class="relative overflow-hidden rounded-3xl bg-red-500 lg:m-5">
    <div
      ref="ttfContainer"
      class="relative z-10 flex flex-col items-center justify-center pb-6 pt-20 lg:pb-16 lg:pt-32">
      <Motion
        :animate="{ opacity: animation ? [0, 1] : 0 }"
        :transition="{ duration: 0.5 }"
        src="/placeholders/homepage/talking-logo.png"
        class="max-h-24 lg:max-h-full"
        tag="img" />
      <Motion
        v-if="title"
        :animate="{ opacity: animation ? [0, 1] : 0 }"
        :transition="{ duration: 0.5, delay: 0.1 }"
        class="mt-10 max-w-2xl px-6 text-center text-3xl leading-tight text-white lg:mt-12 lg:text-6xl lg:leading-[1.1]"
        tag="h2">
        {{ title }}
      </Motion>
      <Motion
        v-if="title"
        :animate="{ opacity: animation ? [0, 1] : 0 }"
        :transition="{ duration: 0.5, delay: 0.2 }"
        class="mt-6 max-w-xl px-6 text-center text-base text-white lg:mt-8 lg:text-xl"
        tag="p">
        {{ copy }}
      </Motion>
      <div class="relative mb-6 mt-20 flex w-full justify-center lg:mb-8 lg:mt-12">
        <div class="relative z-10">
          <img
            :src="`${cdnUrl}/assets/1_our_work/ttf-promo.png`"
            alt="Talking Tom and Friends"
            class="relative" />
          <Motion
            :initial="{ opacity: 0 }"
            :animate="{
              scale: animation ? [0, 1] : 0,
              opacity: [0, 1]
            }"
            :transition="{ duration: 1.2, delay: 0.2, easing: spring() }"
            class="md:mr- absolute right-0 top-0 z-20 -mt-14 mr-16 w-20 overflow-hidden md:w-32 lg:-mt-24 lg:w-52 xl:-mr-44">
            <SvgHeyBubble class="" />
          </Motion>
        </div>

        <SvgCircle
          class="absolute -left-8 top-full -mt-16 w-full lg:-left-10 lg:-mt-52"
          :class="cardSets && cardSets.length > 0 ? 'lg:max-w-xl' : 'max-w-xs lg:max-w-3xl'" />
      </div>

      <template v-if="cardSets?.length > 0">
        <SectionTtfPromoCardSet
          v-for="(cardSet, i) in cardSets"
          :key="i"
          v-bind="cardSet"
          class="mb-6 mt-6 lg:mb-8 lg:mt-8" />
      </template>
    </div>

    <Motion
      :initial="{ opacity: 0 }"
      :animate="{ scale: animation ? [0, 1] : 0, opacity: [0, 1] }"
      :transition="{ duration: 0.8, delay: 0.2, easing: spring() }"
      class="absolute top-0 -mt-2.5 ml-4 w-20 lg:ml-28 lg:mt-28 lg:w-40">
      <SvgFlower />
    </Motion>
    <Motion
      :initial="{ opacity: 0 }"
      :animate="{ scale: animation ? [0, 1] : 0, opacity: [0, 1] }"
      :transition="{ duration: 1, delay: 0.6, easing: spring() }"
      class="absolute right-0 top-0 -mr-2 -mt-2.5 w-24 lg:-mt-8 lg:mr-56 lg:w-56">
      <SvgFlower />
    </Motion>
  </div>
</template>

<script setup lang="ts">
  // @ts-nocheck
  import { onMounted, ref, useTemplateRef } from 'vue'

  import { Motion } from '@motionone/vue/dist/motion-vue.ssr.js'
  import { inView, spring } from 'motion'

  import type { TtfPromoCardSet } from '~/models/cards'

  type Props = {
    title: string
    copy: string
    cardSets: TtfPromoCardSet[]
  }

  const { title = '', copy = '', cardSets = [] } = defineProps<Props>()

  const { cdnUrl } = useRuntimeConfig().public

  const ttfContainer = useTemplateRef<HTMLDivElement>('ttfContainer')
  const animation = ref(false)

  onMounted(() => {
    inView(
      ttfContainer.value,
      () => {
        animation.value = true
      },
      { amount: 0.2 }
    )
  })
</script>
